"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var core_2 = require("@ngx-translate/core");
var environment_service_1 = require("@nw/ui-core-shared/services/environment.service");
var main_store_service_1 = require("@nw/ui-core-shared/store/main-store.service");
var multi_rebid_service_1 = require("@nw/ui-core-shared/services/multi-rebid.service");
var app_ui_action_1 = require("@nw/ui-core-shared/store/actions/app-ui.action");
var DealerblockPlaceBidV1Component = (function () {
    function DealerblockPlaceBidV1Component(environmentService, window, mainStoreService, multiRebidService, translateService, uiActions) {
        this.environmentService = environmentService;
        this.window = window;
        this.mainStoreService = mainStoreService;
        this.multiRebidService = multiRebidService;
        this.translateService = translateService;
        this.uiActions = uiActions;
        this.successBidProcessing = new core_1.EventEmitter();
        this.bidType = '';
        this.bidAutoType = '';
        this.lang = 'en';
        this.bidPlace = { status: undefined };
        this.store$ = mainStoreService.getStore();
    }
    DealerblockPlaceBidV1Component.prototype.ngOnInit = function () {
        var _this = this;
        this.mainStoreService.getStore().select(function (state) { return state.appPrincipal; })
            .subscribe(function (principal) {
            _this.lang = principal.language ? principal.language : 'en';
        });
        this.getBidPrice();
        this.buyerOaUrl = this.environmentService.getEnvironment().interfacePath.buyerOa;
        this.placeBidUrl = this.buyerOaUrl + "/bidDetails.html?vehicleId=" + this.originalVehicleId;
        this.placeAutobidUrl = this.buyerOaUrl + "/previewAutoBidDetails.html?vehicleId=" + this.originalVehicleId;
    };
    DealerblockPlaceBidV1Component.prototype.ngOnChanges = function () {
        this.getBidPrice();
    };
    DealerblockPlaceBidV1Component.prototype.navigateToClassic = function () {
        this.window.open(this.placeBidUrl, '_self');
    };
    DealerblockPlaceBidV1Component.prototype.navigateToAutoBidClassic = function () {
        this.window.open(this.placeAutobidUrl, '_self');
    };
    // if user has bid =>  My Bid expects winningBidMaxAmount, update Bid expects winningBidAmount + bidIncrement
    // if user has no bid =>  Place Bid expects startprice. if there is a winning bid amount, it expects winningBidAmount + bidIncrement
    DealerblockPlaceBidV1Component.prototype.getBidPrice = function () {
        if (!this.userHasBid) {
            this.displayPrice = this.startPrice;
            if (this.winningBidAmount) {
                this.displayPrice = this.winningBidAmount + this.bidIncrement;
            }
            this.bidType = 'place';
            this.bidAutoType = 'autobid';
        }
        else {
            if (this.allowProxyAutoBid) {
                this.bidAutoType = 'myautobid';
                this.displayPrice = this.winningBidMaxAmount;
            }
            else {
                if (this.userIsWinning) {
                    this.displayPrice = this.winningBidMaxAmount;
                    this.bidType = 'my';
                    this.bidPlace = { status: 'winningBid' };
                }
                else {
                    this.displayPrice = this.winningBidAmount + this.bidIncrement;
                    this.bidType = 'update';
                    this.bidPlace = { status: 'loosingBid' };
                    this.updateSuccessBidProcessing(false);
                }
            }
        }
    };
    DealerblockPlaceBidV1Component.prototype.isNumber = function (value) {
        return !isNaN(value);
    };
    DealerblockPlaceBidV1Component.prototype.reBid = function () {
        var _this = this;
        this.bidPlace = { status: 'bidSubmittedToClassic' };
        this.multiRebidService.multiRebid(this.originAuctionId, this.displayPrice, this.year, this.make, this.model, this.vin)
            .map(function (res) { return res.json(); })
            .catch(function (error) {
            _this.bidPlace = { status: 'errorReceived' };
            _this.translateService.get("rebidMessages.errorMessages")
                .subscribe(function (translate) {
                _this.store$.dispatch(_this.uiActions.showGlobalError({
                    message: translate['PARAM_ERROR']
                }));
            });
            return Observable_1.Observable.of(false);
        })
            .subscribe(function (data) {
            if (data && data.multiBids[0].status === 'Failed') {
                _this.bidPlace = { status: 'errorReceived' };
                _this.translateService.get("rebidMessages.errorMessages")
                    .subscribe(function (translate) {
                    _this.store$.dispatch(_this.uiActions.showGlobalError({
                        message: translate[data.multiBids[0].ecode ? data.multiBids[0].ecode : 'PARAM_ERROR']
                    }));
                });
            }
            else if (data && data.multiBids[0].status === 'Success') {
                _this.updateSuccessBidProcessing(true);
                _this.bidPlace = { status: 'bidPlacedToClassic' };
            }
            else {
                // console.log('data: ', data);
            }
        });
    };
    DealerblockPlaceBidV1Component.prototype.updateSuccessBidProcessing = function (ifBidSuccessfullyPlaced) {
        this.successBidProcessing.emit(ifBidSuccessfullyPlaced);
    };
    return DealerblockPlaceBidV1Component;
}());
DealerblockPlaceBidV1Component.decorators = [
    { type: core_1.Component, args: [{
                selector: 'nw-dealerblock-place-bid-v1',
                template: "<!--New logic for rebid functionality: originAuctionId is required-->\n<div *ngIf=\"allowBid && !isCompetitiveBid && originAuctionId && bidIncrement && isNumber(displayPrice)\">\n\n    <button *ngIf=\"(!userHasBid || (userHasBid && userIsWinning))\" class=\"btn btn-block wrap-content\" (click)=\"navigateToClassic()\"\n            [attr.data-a8n]=\"'db-' + bidType + '-bid'\"\n            [ngClass]=\"{'btn-v1-primary-5-blue': bidType === 'place', 'btn-v1-primary-5-green': bidType === 'my'}\">\n        {{((bidType === 'place') ? 'dealerBlockLayout.placeBid' : 'dealerBlockLayout.myBid') | translate }} {{ displayPrice | nwCurrency: lang }}</button>\n\n    <!--Disable button and show spinner when placed to Classic-->\n    <button *ngIf=\"(userHasBid && !userIsWinning) && (bidPlace.status !=='bidPlacedToClassic')\" [disabled]=\"bidPlace.status =='bidSubmittedToClassic'\" class=\"btn btn-block wrap-content\" (click)=\"reBid()\"\n            [attr.data-a8n]=\"'db-' + bidType + '-bid'\"\n            [ngClass]=\"{'btn-v1-primary-5-red': bidType === 'update'}\"><span *ngIf=\"bidPlace.status =='bidSubmittedToClassic' && bidPlace.status !=='!errorReceived'\" class=\"fas fa-spinner fa-pulse fa-2x fa-fw\"></span>\n        {{'dealerBlockLayout.updateBid' | translate }} {{ displayPrice | nwCurrency: lang }}</button>\n\n    <!--Change color to green, show message 'processing' and show spinner when API successfully responded but IoT event did not come yet-->\n    <button *ngIf=\"bidPlace.status == 'bidPlacedToClassic'\" class=\"btn btn-block wrap-content\"\n            [attr.data-a8n]=\"'db-' + bidType + '-bid'\"\n            [ngClass]=\"'btn-v1-primary-5-green'\">\n        <span class=\"fas fa-spinner fa-pulse fa-2x fa-fw\"></span>{{'dealerBlockLayout.successBidProcessing' | translate }}</button>\n\n</div>\n<div class=\"edit-bid-amount\" *ngIf=\"userHasBid && !userIsWinning && originAuctionId && allowBid && (bidPlace.status !=='bidPlacedToClassic')\">\n    <button data-a8n=\"db-watchlist-edit-bid-amount\" class=\"btn btn-block wrap-content edit-bid-amount-btn\" (click)=\"navigateToClassic()\">{{ 'dealerBlockLayout.editBidAmount' | translate}}</button>\n</div>\n\n<!--Old logic to navigate to Classic to rebid functionality: originAuctionId is required-->\n<div *ngIf=\"allowBid && !isCompetitiveBid && (!originAuctionId || !bidIncrement || !isNumber(displayPrice))\">\n    <div class=\"w-100\" *ngIf=\"allowBid && !isCompetitiveBid\">\n        <button class=\"btn btn-block wrap-content\" (click)=\"navigateToClassic()\"\n                [attr.data-a8n]=\"'db-' + bidType + '-bid'\"\n                [ngClass]=\"{'btn-v1-primary-5-blue': bidType === 'place', 'btn-v1-primary-5-green': bidType === 'my', 'btn-v1-primary-5-red': bidType === 'update'}\">\n            {{((bidType === 'place') ? 'dealerBlockLayout.placeBid' : ((bidType === 'my') ? 'dealerBlockLayout.myBid' : 'dealerBlockLayout.updateBid')) | translate }} {{ displayPrice | nwCurrency: lang }}</button>\n    </div>\n</div>\n\n<nw-deadlerblock-bid-message *ngIf=\"bidPlace.status == 'loosingBid' || bidPlace.status == 'winningBid'\" [allowBid]=\"allowBid\" [isCompetitiveBid]=\"isCompetitiveBid\" [bidType]=\"bidType\"></nw-deadlerblock-bid-message>\n\n<div *ngIf=\"allowBid && isCompetitiveBid\">\n    <button class=\"btn btn-block wrap-content\" (click)=\"navigateToClassic()\"\n            [attr.data-a8n]=\"'db-watchlist-preview-competitive-bid'\"\n            [ngClass]=\"{'btn-v1-primary-5-blue': bidType === 'place', 'btn-v1-primary-5-green': bidType === 'my', 'btn-v1-primary-5-red': bidType === 'update'}\">\n        {{'dealerBlockLayout.competitiveBid' | translate }} {{ displayPrice | nwCurrency: lang }}</button>\n</div>\n\n<div *ngIf=\"allowProxyAutoBid\">\n    <button class=\"btn btn-block autobid wrap-content\" (click)=\"navigateToAutoBidClassic()\"\n            [attr.data-a8n]=\"'db-watchlist-preview-proxy-' + bidAutoType\">\n        {{ ((bidAutoType === 'autobid') ? 'dealerBlockLayout.autoBid' : 'dealerBlockLayout.myAutoBid') | translate }}\n        <span *ngIf=\"bidAutoType !== 'autobid'\">{{ displayPrice | nwCurrency: lang }}</span>\n    </button>\n</div>\n\n",
                styles: [""]
            },] },
];
/** @nocollapse */
DealerblockPlaceBidV1Component.ctorParameters = function () { return [
    { type: environment_service_1.EnvironmentService, },
    { type: undefined, decorators: [{ type: core_1.Inject, args: ['windowObject',] },] },
    { type: main_store_service_1.MainStoreService, },
    { type: multi_rebid_service_1.MultiRebidService, },
    { type: core_2.TranslateService, },
    { type: app_ui_action_1.AppUiActions, },
]; };
DealerblockPlaceBidV1Component.propDecorators = {
    'allowBid': [{ type: core_1.Input },],
    'userHasBid': [{ type: core_1.Input },],
    'userIsWinning': [{ type: core_1.Input },],
    'winningBidAmount': [{ type: core_1.Input },],
    'bidIncrement': [{ type: core_1.Input },],
    'winningBidMaxAmount': [{ type: core_1.Input },],
    'startPrice': [{ type: core_1.Input },],
    'originalVehicleId': [{ type: core_1.Input },],
    'allowProxyAutoBid': [{ type: core_1.Input },],
    'isCompetitiveBid': [{ type: core_1.Input },],
    'originAuctionId': [{ type: core_1.Input },],
    'year': [{ type: core_1.Input },],
    'make': [{ type: core_1.Input },],
    'model': [{ type: core_1.Input },],
    'vin': [{ type: core_1.Input },],
    'successBidProcessing': [{ type: core_1.Output },],
};
exports.DealerblockPlaceBidV1Component = DealerblockPlaceBidV1Component;
//# sourceMappingURL=dealerblock-place-bid-v1.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/components/components-v1/dealerblock-place-bid-v1/dealerblock-place-bid-v1.component.js
// module id = U9Wt
// module chunks = 0